import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { getStyles, translate } from '../../../shared/utility';

import SearchDropdown from './SearchDropdown/SearchDropdown';

import Input from '../../UI/Input/Input';
import Button from '../../UI/Button/Button';
import Tag from '../../UI/Tag/Tag';
import Icon from '../../UI/Icon/Icon';

import localStyles from './SearchFocus.scss';
const styles = getStyles(localStyles);

class SearchFocus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputConfig: {
                type: 'text',
                name: 'input',
                id: this.props.id
            },
            searchValue: '',
            isDropdownOpen: false, // is the dropdown opened
            dropdownMode: 'toggle', // modes: 'autocomplete', 'toggle'
            hilightedAutocompleteItem: 0, // index of 'hilighted' element in autocomplete list
            historyItems: [],// array with recent searches,
            requestedCurrentLocation: false
        };

        this.refSearchBox = React.createRef();
    }

    /* * * * * * * * *
     * REACT METHODS *
     * * * * * * * * */

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchAutocompleteData !== this.props.searchAutocompleteData) {
            this.setState(this.state.isDropdownOpen ? { hilightedAutocompleteItem: 0 } : { isDropdownOpen: true, hilightedAutocompleteItem: 0 });
        }

        if (prevState.isDropdownOpen !== this.state.isDropdownOpen) {
            this.state.isDropdownOpen ? document.addEventListener('click', this.documentOnClick) : document.removeEventListener('click', this.documentOnClick);
        }

        if (prevProps.searchLocationData !== this.props.searchLocationData && !!this.props.searchLocationData) {
            this.props.onSetGlobalState('activeSearchLocation', this.props.searchLocationData);
        }
        if (prevProps.activeSearchLocation !== this.props.activeSearchLocation && !!this.props.activeSearchLocation) {
            const historyItems = this.state.historyItems.filter(currentItem => currentItem.id !== this.props.activeSearchLocation.id).concat(this.props.activeSearchLocation);
            if (!!this.props.activeMainType) {
                const location = !!this.props.activeSearchLocation ? `?location=${this.props.activeSearchLocation.id}` : null;
                const itemTypes = this.props.selectedItemTypeIds.length ? `${location ? '&' : '?'}itemTypes=${this.props.selectedItemTypeIds.toString()}` : null;

                this.props.history.push({ pathname: `/items/${this.props.activeMainType.id}`, search: `${location ? location : ''}${itemTypes ? itemTypes : ''}` });
            }

            this.setState({
                searchValue: '',
                isDropdownOpen: false,
                dropdownMode: 'toggle',
                historyItems: historyItems
            });
        }

        if(prevProps.currentLocationLoading !== this.props.currentLocationLoading && !this.props.currentLocationLoading && !!this.props.currentLocationError && this.state.requestedCurrentLocation) {
            this.props.addNotification({ message: `${translate('notifications.details.currentLocationError', this.props.language)} ${this.props.currentLocationError}`, type: 'error' });
        }
    }

    /* * * * * * * * * * * * *
     * AUTOCOMPLETE METHODS  *
     * * * * * * * * * * * * */
    updateAutocompleteHilightedItem = (delta, absolute) => {
        const updatedHilight = Math.max(0, Math.min(this.props.searchAutocompleteData.length - 1, (absolute ? delta : this.state.hilightedAutocompleteItem + delta)));

        this.setState({ hilightedAutocompleteItem: updatedHilight });
    }

    /* * * * * * * * * * * * * * *
     * CURRENT LOCATION METHODS  *
     * * * * * * * * * * * * * * */
    activateCurrentLocation = () => {
        if (this.props.currentLocationData) {
            this.props.onSetGlobalState('activeSearchLocation', this.props.currentLocationData);
        } else if (!this.props.currentLocationLoading && this.props.currentLocationAvailable) {
            this.props.onFetchCurrentLocation();
            this.setState({requestedCurrentLocation: true});
        }
    }

    /* * * * * * * * * * * * * *
     * MAIN ITEM TYPE METHODS  *
     * * * * * * * * * * * * * */
    toggleMainItemType = (id) => {
        this.setState({ isDropdownOpen: false });
        if (!!this.props.activeMainType && this.props.activeMainType.id === id) {
            this.props.onSetActiveTypes();
            this.props.history.push({ pathname: '/' });
        } else {
            const location = !!this.props.activeSearchLocation ? `?location=${this.props.activeSearchLocation.id}` : null;
            const itemTypes = this.props.selectedItemTypeIds.length ? `${location ? '&' : '?'}itemTypes=${this.props.selectedItemTypeIds.toString()}` : null;

            this.props.history.push({ pathname: `/items/${id}`, search: `${location ? location : ''}${itemTypes ? itemTypes : ''}` });
        }
    }

    /* * * * * * * * * *
     * EVENT HANDLERS  *
     * * * * * * * * * */
    handleChange = (event) => {
        const val = event.target.value.trim();
        if (val.length) {
            this.props.getSearchAutocomplete(val, this.props.locale);
        }

        const dropdownMode = val.length ? 'autocomplete' : 'toggle';

        this.setState({ searchValue: event.target.value, dropdownMode: dropdownMode });
    }

    handleKeyUp = (event) => {
        if (this.state.dropdownMode === 'autocomplete') {
            switch (event.key) {
                case 'Enter':
                    event.preventDefault();
                    this.props.getSearchLocationDetails(this.props.searchAutocompleteData[this.state.hilightedAutocompleteItem].place_id);
                    break;

                default:
                    return;
            }
        }
    }

    handleKeyDown = (event) => {
        if (this.state.dropdownMode === 'autocomplete') {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    this.updateAutocompleteHilightedItem(1);
                    break;

                case 'ArrowUp':
                    event.preventDefault();
                    this.updateAutocompleteHilightedItem(-1);
                    break;

                default:
                    return;

            }
        }
    }

    handleFocus = (event) => {
        this.handleChange(event);
    }

    documentOnClick = (event) => {
        if (!!this.refSearchBox && !!this.refSearchBox.current && !this.refSearchBox.current.contains(event.target)) {
            this.setState({ isDropdownOpen: false });
        }
    }

    wrapperOnClick = () => {
        this.setState({ isDropdownOpen: true });
    }

    handleButtonClick = (event) => {
        event.stopPropagation();
        if (!!this.props.activeSearchLocation || !!this.props.activeMainType) {
            this.setState({ isDropdownOpen: false });
            this.props.onSetGlobalState('activeSearchLocation', null);
            this.props.onSetActiveTypes();

            this.props.history.push({ pathname: '/' });
        } else if (this.state.dropdownMode === 'autocomplete' && this.state.isDropdownOpen) {
            this.props.getSearchLocationDetails(this.props.searchAutocompleteData[this.state.hilightedAutocompleteItem].place_id);
        }
    }

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        const locationTag = !!this.props.activeSearchLocation ? (
            <Tag classes={styles('search__tag')}>
                {this.props.activeSearchLocation.value === 'CURRENT_LOCATION' ?
                    translate('toolbar.searchbar.currentLocation.tagValue', this.props.language) :
                    this.props.activeSearchLocation.value
                }
            </Tag>
        ) : null;

        const typeTag = !!this.props.activeMainType ? (
            <Tag classes={styles('search__tag')}>{this.props.activeMainType.name}</Tag>
        ) : null;

        const tags = locationTag || typeTag ? (
            <div className={styles('search__tags-container', 'flex')}>
                {typeTag}
                {locationTag}
            </div>
        ) : null;

        return (
            <div className={styles('search')} ref={this.refSearchBox}>
                <div
                    className={styles('search__box', 'flex', 'flex--align-center')}
                    onClick={this.wrapperOnClick}
                >
                    <label
                        htmlFor={this.state.inputConfig.id}
                        className={styles('search__label')}
                    >
                        <Icon icon={'search'} />
                    </label>

                    {tags}

                    <Input
                        attrs={{ ...this.state.inputConfig, placeholder: translate('toolbar.searchbar.placeholder', this.props.language) }}
                        value={this.state.searchValue}
                        events={{
                            keyDown: this.handleKeyDown,
                            keyUp: this.handleKeyUp,
                            focus: this.handleFocus,
                            change: this.handleChange
                        }}
                        classes={styles('search__input')}
                        modifiers={['no-border', 'collapsed', 's']}
                    />
                    <Button
                        modifiers={!!locationTag || !!typeTag ? ['xxs', 'circle'] : ['m', this.props.communityDetailsLoading ? '' : 'primary']}
                        classes={styles(!!locationTag || !!typeTag ? 'search__button--remove' : 'search__button')}
                        events={{ click: this.handleButtonClick}}
                    >
                        {!!locationTag || !!typeTag ? '✕' : translate('toolbar.searchbar.buttonText', this.props.language)}
                    </Button>
                </div>

                <SearchDropdown
                    isOpen={this.state.isDropdownOpen}
                    mode={this.state.dropdownMode}
                    hilighted={this.state.hilightedAutocompleteItem}
                    historyItems={this.state.historyItems}

                    updateHilighted={(index) => this.updateAutocompleteHilightedItem(index, true)}
                    setActiveHistoryItem={(item) => this.props.onSetGlobalState('activeSearchLocation', item)}
                    setActiveCurrentLocation={this.activateCurrentLocation}
                    toggleMainItemType={(id) => this.toggleMainItemType(id)}
                />
            </div>
        );
    }
}

SearchFocus.propTypes = {
    // properties
    history: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    activeMainType: PropTypes.object,
    activeSearchLocation: PropTypes.object,
    selectedItemTypeIds: PropTypes.arrayOf(PropTypes.number),

    searchAutocompleteData: PropTypes.arrayOf(PropTypes.object),
    searchLocationData: PropTypes.object,
    currentLocationAvailable: PropTypes.bool,
    currentLocationData: PropTypes.object,
    currentLocationLoading: PropTypes.bool,
    currentLocationError: PropTypes.string,
    communityDetailsLoading: PropTypes.bool,

    locale: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,

    // functions
    onFetchCurrentLocation: PropTypes.func.isRequired,
    getSearchAutocomplete: PropTypes.func.isRequired,
    getSearchLocationDetails: PropTypes.func.isRequired,
    onSetGlobalState: PropTypes.func.isRequired,
    onSetActiveTypes: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        activeMainType: state.global.activeMainType,
        activeSearchLocation: state.global.activeSearchLocation,
        selectedItemTypeIds: state.global.selectedItemTypeIds,

        searchAutocompleteData: state.list.searchAutocomplete.data,
        searchLocationData: state.details.searchLocation.data,
        currentLocationAvailable: state.global.currentLocationAvailable,
        currentLocationData: state.details.currentLocation.data,
        currentLocationLoading: state.details.currentLocation.loading,
        currentLocationError: state.details.currentLocation.error,
        communityDetailsLoading: state.details.community.loading,

        locale: state.global.localization.locale,
        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchCurrentLocation: () => dispatch(actions.fetchCurrentLocation()),
        getSearchAutocomplete: (search, locale) => dispatch(actions.fetchSearchAutocomplete(search, locale)),
        getSearchLocationDetails: (locationId) => dispatch(actions.fetchSearchLocationDetails(locationId)),
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value)),
        onSetActiveTypes: (activeMainType, activeItemTypes) => dispatch(actions.setActiveTypes(activeMainType, activeItemTypes)),
        addNotification: (data) => dispatch(actions.addNotification(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchFocus));



// WEBPACK FOOTER //
// ./src/components/Navigation/SearchFocus/SearchFocus.js